import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/AccountsOpeningReqs/AccountsOpeningReqs'


function* getAccountsOpening(action) {
    try {
        const result = yield call(req.getAccountsOpeningListReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch opening balances");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* createAccountsOpening(action) {
    try {
        const result = yield call(req.createAccountsOpeningReq, action);
        if (result.success === true) {
            toast.success(result.message || "Opening balance created successfully");
            yield put({ type: types.CREATE_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CREATE_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to create opening balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* updateAccountsOpening(action) {
    try {
        const result = yield call(req.updateAccountsOpeningReq, action);
        if (result.success === true) {
            toast.success(result.message || "Opening balance updated successfully");
            yield put({ type: types.UPDATE_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.UPDATE_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to update opening balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* deleteAccountsOpening(action) {
    try {
        const result = yield call(req.deleteAccountsOpeningReq, action);
        if (result.success === true) {
            toast.success(result.message || "Opening balance deleted successfully");
            yield put({ type: types.DELETE_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.DELETE_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to delete opening balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* downloadAccountsOpening(action) {
    try {
        const result = yield call(req.downloadAccountsOpeningReq, action);
        // Handle blob download
        const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `opening-balances.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        yield put({ type: types.DOWNLOAD_ACCOUNTS_OPENING_SUCCESS });
        toast.success("Download started");
    } catch (e) {
        console.log(e)
        yield put({ type: types.DOWNLOAD_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Failed to download");
    }
}

function* bulkUploadAccountsOpening(action) {
    try {
        const result = yield call(req.bulkUploadAccountsOpeningReq, action);
        if (result.success === true) {
            yield put({ type: types.BULK_UPLOAD_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.(result.data);
            toast.success(result.message || "Bulk upload completed");
        } else {
            yield put({ type: types.BULK_UPLOAD_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Bulk upload failed");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_UPLOAD_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


function* getGlAccountsOpening(action) {
    try {
        const result = yield call(req.getGlAccountsOpeningReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_GL_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_GL_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch GL accounts opening balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_GL_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


function* saveGlAccountsOpening(action) {
    try {
        const result = yield call(req.saveGlAccountsOpeningReq, action);
        if (result.success === true) {
            toast.success(result.message || "Opening balance saved successfully");
            yield put({ type: types.SAVE_GL_ACCOUNTS_OPENING_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.SAVE_GL_ACCOUNTS_OPENING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to save opening balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SAVE_GL_ACCOUNTS_OPENING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


export default function* AccountsOpeningSaga() {
    yield takeLatest(types.GET_ACCOUNTS_OPENING, getAccountsOpening);
    yield takeLatest(types.CREATE_ACCOUNTS_OPENING, createAccountsOpening);
    yield takeLatest(types.UPDATE_ACCOUNTS_OPENING, updateAccountsOpening);
    yield takeLatest(types.DELETE_ACCOUNTS_OPENING, deleteAccountsOpening);
    yield takeLatest(types.DOWNLOAD_ACCOUNTS_OPENING, downloadAccountsOpening);
    yield takeLatest(types.BULK_UPLOAD_ACCOUNTS_OPENING, bulkUploadAccountsOpening);
    yield takeLatest(types.GET_GL_ACCOUNTS_OPENING, getGlAccountsOpening);
    yield takeLatest(types.SAVE_GL_ACCOUNTS_OPENING, saveGlAccountsOpening);
}
